import type { FC, ReactNode } from 'react';
import { NavLink } from 'react-router';
import { AlertTriangle, Info } from 'lucide-react';

import { CompactText } from 'ui/CompactText';

import classes from './CabinetBanner.module.scss';

export type CabinetBannerProps = {
  title: string;
  text?: string;
  items?: string[];
  icon?: ReactNode;
  linkTo?: string;
  linkLabel?: string;
  variant?: 'info' | 'warning';
};

export const CabinetBanner: FC<CabinetBannerProps> = ({
  title,
  text,
  items,
  icon,
  linkTo,
  linkLabel,
  variant = 'info',
}) => (
  <div
    className={`${classes.banner} ${classes[`banner--${variant}`]}`}
    role='status'
  >
    <div className={classes.banner__head}>
      {/* p7: у каждой плашки есть иконка (по умолчанию - по варианту) */}
      <span className={classes.banner__icon} aria-hidden='true'>
        {icon ?? (variant === 'warning' ? <AlertTriangle size={18} /> : <Info size={18} />)}
      </span>
      <p className={classes.banner__title}>{title}</p>
    </div>
    {text && <CompactText className={classes.banner__text}>{text}</CompactText>}
    {items && items.length > 0 && (
      <ul className={classes.banner__list}>
        {items.map((item) => (
          <li  key={item}> 	-    {item}</li>
        ))}
      </ul>
    )}
    {linkTo && linkLabel && (
      <NavLink to={linkTo} className={classes.banner__link}>
        {linkLabel}
      </NavLink>
    )}
  </div>
);
